<template lang="html">

<div v-if=" isAdmin && isAdmin.type == 'admin'">
  <TabNav :tabs="companyList" :selected="selected" :tabType="true" @selected="setSelected" id="companyNav">
    <Tab v-for="company in companyList" :key="company" :isSelected="selected === company">
      <!-- Sadržaj ide posle loading provere dole -->
    </Tab>
  </TabNav>
</div>

<!-- NE-ADMIN: direktno prikaži bez tabova -->
<div v-else>
  <Tab :isSelected="true">
    <!-- Sadržaj ide posle loading provere dole -->
  </Tab>
</div>
        <div v-if="loading" class="loader">
 
  </div>
  <div v-if="!loading && selected">
        <div class="validation">
          {{validation}}
        </div>
        <h2>{{selected}}</h2>
        <div class="">
          <label for="">Pozicija:&nbsp;&nbsp;</label>
          <input type="text" name="" v-model="searchPosition">
        </div>
        <div class="d-flex">
        <div class="mt-2 ">
          <button type="button" name="button" class="btn-info rounded-2 fw-bold" @click="filter()">Filtriraj</button>
        </div>
        <div class="mt-2 mx-2" v-if="isAdmin && isAdmin.type == 'admin'">
          <button type="button" name="button" class="btn-secondary rounded-2 fw-bold"   @click="addCandidate()">Dodaj kandidata</button>
        </div>
        <div class="mt-2  mx-2" v-if="!pdfActivate">
          <button type="button" name="button" class="btn-danger rounded-2 fw-bold" @click="makePdfFile()">Pdf</button>
        </div>
      </div>
  
        <!-- <input type="text" name="" v-model="searchSector"> -->
        <div class="row justify-content-center" >
          <div class="row justify-content-center">
          <div class="col-md-12 p-0 d-flex justify-content-center">
        <div class="bg-danger bg-gradient text-center fw-bold row fs-4 col-md-12 justify-content-center text-white py-2 mt-2 ">KANDIDATI</div>
        </div>
      </div>
      </div>
      <div id="pdf-wrapper"  :class="letterSpacing ? 'letterSpacing' : ''">
        <div :class="pdfActivate? 'my-5' : 'my-2'"  v-for="userX in interviewCandidates"  :key="userX._id" :data-candidate-id="userX._id" data-include-in-pdf="false" >
            <div class="row">
              <div class="container pt-1">
  <div class="row">
    <div class="col-md-12 col-sm-12">
      <div class="form-group row mb-2">
        <label class="col-12 col-md-4 col-form-label fw-bold flex align-items-center">Pozicija/Position:</label>
        <div class="col-12 col-md-8">
          <input v-model="userX.position" class="form-control input-gray fw-bold" />
        </div>
      </div>

      <div class="form-group row mb-2">
        <label class="col-12 col-md-4 col-form-label fw-bold flex align-items-center">Ime/Name:</label>
        <div class="col-12 col-md-8">
          <input v-model="userX.fullName" class="form-control input-gray fw-bold" />
        </div>
      </div>

      <div class="form-group row mb-2">
        <label class="col-12 col-md-4 col-form-label fw-bold flex align-items-center">Email:</label>
        <div class="col-12 col-md-8">
          <input v-model="userX.email" type="email" class="form-control input-gray fw-bold" />
        </div>
      </div>

      <div class="form-group row mb-2">
        <label class="col-12 col-md-4 col-form-label fw-bold flex align-items-center">Godište/Year of birth:</label>
        <div class="col-12 col-md-8">
          <input v-model="userX.yearOfBirth" class="form-control input-gray fw-bold" />
        </div>
      </div>
    </div>
  </div>
</div>

<div class="container mt-decrease" >
  <div class="row">
    <div class="col-md-12 col-sm-12">
      <div class="form-group row mb-2">
        <label class="col-12 col-md-4 col-form-label fw-bold flex align-items-center">Mesto stanovanja/Place of residence:</label>
        <div class="col-12 col-md-8">
          <input v-model="userX.placeOfLiving" class="form-control input-gray fw-bold" />
        </div>
      </div>

      <div class="form-group row mb-2">
        <label class="col-12 col-md-4 col-form-label fw-bold flex align-items-center">Obrazovanje/Education:</label>
        <div class="col-12 col-md-8">
          <input v-model="userX.education" class="form-control input-gray fw-bold" />
        </div>
      </div>

      <div class="form-group row mb-2">
        <label class="col-12 col-md-4 col-form-label fw-bold flex align-items-center">Otkazni period/No. period:</label>
        <div class="col-12 col-md-8">
          <input v-model="userX.noticePeriod" class="form-control input-gray fw-bold" />
        </div>
      </div>

      <div class="form-group row mb-2">
        <label class="col-12 col-md-4 col-form-label fw-bold flex align-items-center">Finansijska očekivanja/Salary range:</label>
        <div class="col-12 col-md-8">
          <input v-model="userX.financialExpectations" class="form-control input-gray fw-bold" />
        </div>
      </div>
    </div>
  </div>
</div>

            </div>
            <div class="mt-2 row d-flex justify-content-center px-1">
  <div class="col-md-12 p-0">
    <div class="header-red d-flex fw-bold align-items-center justify-content-center bg-danger bg-gradient w-100 text-center text-white box-header large-font">
      MOTIVACIJA/MOTIVATION
    </div>

    <div v-show="pdfActivate" class="text-justify input-fake-textarea w-100 px-3" :class="pdfActivate? 'large-font' :''">
      {{ userX.motivationForEmployment }}
    </div>

    <textarea v-show="!pdfActivate" v-model="userX.motivationForEmployment" class="text-justify input-gray input-large w-100 px-3"></textarea>
  </div>
</div>
           <div class="mt-2 row d-flex justify-content-center px-1">
  <div class="col-md-12 p-0">
    <div
      class="header-red d-flex fw-bold align-items-center justify-content-center bg-danger bg-gradient w-100 text-center text-white box-header large-font">
      KOMENTAR/COMMENT
    </div>

    <!-- Prikaz za PDF -->
    <div v-show="pdfActivate" class="text-justify input-fake-textarea w-100 px-3" :class="pdfActivate? 'large-font' :''">
      {{ userX.comment }}
    </div>

    <!-- Obično prikazivanje -->
    <textarea v-show="!pdfActivate" v-model="userX.comment" class="text-justify input-gray input-large w-100 px-3"></textarea>
  </div>
</div>
          <div class="mt-2 d-flex justify-content-center " id="btn-wrapper" >
          <button v-if="!userX._id" class="mx-2 btn-primary " type="button" name="button" @click="submitCandidate(userX)">Snimi</button>
          <button v-if="userX._id && !pdfActivate && isAdmin && isAdmin.type == 'admin'" class="mx-1 btn-secondary btns-func" type="button" name="button" @click="updateCandidate(userX)" >Izmeni</button>
          <button v-if="userX._id && !pdfActivate && isAdmin && isAdmin.type == 'admin'" class="mx-1 btn-danger btns-func" type="button" name="button" @click="removeCandidate(userX._id)">Ukloni Kandidata</button>
          <button v-if="userX._id && !pdfActivate" class="mx-1 btn-info btns-func" type="button" name="button" @click="togglePdfMark(userX._id) "    :class="['mx-1 btns-func', selectedTodPdf.includes(userX._id) ? 'pdf-selected' : 'btn-info']"> {{ selectedTodPdf.includes(userX._id) ? 'Ukloni iz PDF' : 'Dodaj u PDF' }}</button>
        </div>
        <div class='divider'></div>
      </div>
        </div>
    </div>

    
    <div v-if="this.savedSuccessfully" class="bg-success p-3 rounded mb-3 text-white text-center fw-bold fixed-top py-5 ">Promene uspešno snimljene!</div>
  </template>
  
  <script>

// eslint-disable-next-line no-unused-vars

  // @ is an alias to /src
  // eslint-disable-next-line no-unused-vars
  import {mapActions,mapGetters} from 'vuex';
import html2canvas from 'html2canvas';
// eslint-disable-next-line no-unused-vars
import jsPDF from "jspdf";
  // eslint-disable-next-line no-unused-vars
  import TabNav from '@/components/TabNav.vue'
  import Tab from '@/components/Tab.vue'
  export default {
    computed: {
  ...mapGetters(['companys', 'users', 'user', 'usersSameCompany']),
  isAdmin() {
    return this.user;
  }
},
    selectedCandidatesForPdf() {
    if (this.selectedTodPdf.length === 0) {
      // Ako nije izabrano ništa, vrati sve kandidate
      return this.interviewCandidates;
    } else {
      // Vrati samo selektovane
      return this.interviewCandidates.filter(c => this.selectedTodPdf.includes(c._id));
    }
  },
    components:{
      TabNav,
      Tab,
    },
    data(){
      return{
        selectedTodPdf:[],
        letterSpacing: false,
        selected: '',
        companyList:[],
        //each element is a list of users (different lists are for different companies)
        listOfListsOfUsers:[],
        validation:"",
        tester:"",
        collegue:[],
        pass:[],
        sektori:[],
        radnaMesta:[],
        iMemory:0,
        searchPosition:'',
        searchSector:'',
        searchRM:'',
        finalList:[],
        prosiriList:[],
        loading:false,
        savedSuccessfully: false,
        saveFailed: false,
        usernameExists: false,
        interviewCandidates:[],
        tempTab:'',
        pdfActivate:false,
        showDropdownCompanies:true,
      }
    },
    mounted() {
  this.$nextTick(() => {
    this.autoResizeTextareas();
  });
},
    watch: {
  interviewCandidates: {
    handler() {
      this.$nextTick(() => {
        this.autoResizeTextareas();
      });
    },
    deep: true
  }
},

    methods: {
      ...mapActions(['getCompanies','getAllUsers','getProfile','deleteInterviewCandidate','getCollegues','setNadredjeni','changePass','updateInterviewCandidate','addInterviewCandidate']),
      async setSelected(tab){
        this.loading=true;
        this.tempTab = tab;
        this.selected=tab;
        await this.getCollegues(tab);
        let tempCompany;
        for (var i = 0; i < this.companys.length; i++) {
          if(this.companys[i].name == this.selected){
            tempCompany=this.companys[i];
          }
        }
     this.interviewCandidates = tempCompany.interviewCandidates
        this.sektori=[];
        this.radnaMesta=[];
  
        for ( i = 0; i < tempCompany.sektori.length; i++) {
          this.sektori.push(tempCompany.sektori[i].name);
          for (var j = 0; j < tempCompany.sektori[i].radnaMesta.length; j++) {
            this.radnaMesta.push(tempCompany.sektori[i].radnaMesta[j]);
          }
        }
  
        //////////////
        for ( i = 0; i < this.companyList.length; i++) {
          if(this.companyList[i]==this.selected){
            this.currentCompanyName=this.companyList[i];
            this.iMemory=i;
          }
        }
  
        this.finalList=[];
        this.prosiriList=[];
  
        for ( i = 0; i < this.usersSameCompany.length; i++) {
            this.finalList.push(this.usersSameCompany[i]);
            this.prosiriList.push(false);
        }
  
        /////////
        this.loading=false;
      },
  
      activateProsiri(index){
        // console.log("ProsiriList[index]:",this.);
        this.prosiriList[index]=!this.prosiriList[index];
      },
      async submitCandidate(candidate){
        candidate.company = this.selected;

      this.loading=true;
      await this.addInterviewCandidate(candidate)
      await this.notificationSuccess();
      this.loading = false;
      this.validation=`Uspesno dodat kandidat`;
      await this.getCompanies()
      await this.setSelected(this.tempTab)
    
      },
       async removeCandidate(userID){
        let data = {
          company:this.selected,
          candidateId:userID
        }
        this.validation="";
        await this.deleteInterviewCandidate(data);
        this.validation=`Uklonjen kandidat id=${userID}`;
        await this.getCompanies()
        await this.setSelected(this.tempTab)
    
      },
  
      notificationSuccess() {
            this.savedSuccessfully = true;
            setTimeout(() => 
              this.savedSuccessfully = false, 5000
             );
          },
        notificationFail() {
          this.saveFailed = true;
          setTimeout(() => 
            this.saveFailed = false, 5000
            );
        },
      async updateCandidate(candidate){ 
      this.loading=true;
      candidate.company = this.selected;
      await this.updateInterviewCandidate(candidate);
      this.loading = false;
      this.notificationSuccess();
      this.validation=`Sacuvane izmene`;
      await this.getCompanies()
      await this.setSelected(this.tempTab)
        
    },
    async filter() {
  this.loading = true;

  const searchLower = this.searchPosition.toLowerCase().trim();
  const company = this.companys.find(c => c.name === this.selected);

  if (!company) {
    this.validation = "Kompanija nije pronađena.";
    this.loading = false;
    return;
  }

  if (!searchLower) {
    this.interviewCandidates = company.interviewCandidates;
    this.validation = "Prikazani svi kandidati.";
  } else {
    this.interviewCandidates = company.interviewCandidates.filter(candidate =>
      candidate.position && candidate.position.toLowerCase().includes(searchLower)
    );

    if (this.interviewCandidates.length === 0) {
      this.validation = "Nema kandidata za zadatu poziciju.";
    } else {
      this.validation = `Pronađeno kandidata: ${this.interviewCandidates.length}`;
    }
  }

  this.loading = false;
},
pdfDone(){
  this.pdfActivate = false;
},

exportToPDFCanvas() {
  this.pdfActivate = true;

  // Privremeno sakrij dugmad

  //const element = document.getElementById("pdf-wrapper"); // <-- OVDE promenjeno
  //const buttons = element.querySelectorAll("button");
  //const labels = element.querySelectorAll(".left-margin")
  //buttons.forEach(btn => btn.style.display = "none");
  //labels.forEach(label => label.classList.add("margin-left"));

  //html2canvas(element, {
    //scale: 2,
    //useCORS: true // ako koristiš slike sa CORS domena
  //}).then(canvas => {
    //const imgData = canvas.toDataURL("image/png");
    //const pdf = new jsPDF("p", "mm", "a4");

    //const imgProps = pdf.getImageProperties(imgData);
    //const pdfWidth = pdf.internal.pageSize.getWidth();
    //const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

    //pdf.addImage(imgData, "PNG", 0, 0, pdfWidth, pdfHeight);
    //pdf.save(`Izvestaj_${this.selected}.pdf`);

    // Vrati dugmad
    //buttons.forEach(btn => btn.style.display = "");
    //labels.forEach(label => label.classList.remove("margin-left"));
  //});
},
  addCandidate(){
      const candidateValues = 
        {                
           position:"",
           fullName:"",
           email:"",
           yearOfBirth:"",
           placeOfLiving:"",
           education:"",
           motivationForEmployment:"",
           noticePeriod:"",
           comment:"",
           financialExpectations:""
                    
        }
       this.interviewCandidates.unshift(candidateValues)
    
    },
    autoResizeTextareas() {
    this.$nextTick(() => {
      const textareas = document.querySelectorAll('textarea');
      textareas.forEach(textarea => {
        textarea.style.height = 'auto';
        textarea.style.height = textarea.scrollHeight + 'px';
        textarea.addEventListener('input', () => {
          textarea.style.height = 'auto';
          textarea.style.height = textarea.scrollHeight + 'px';
        });
      });
    });
  },
  async makePdfFile() {
  this.pdfActivate = true;
  this.letterSpacing = true;

  this.$nextTick(async () => {
    const wrapper = document.querySelector("#pdf-wrapper");
    const candidates = wrapper.querySelectorAll("[data-candidate-id]");

    const doc = new jsPDF("p", "pt", "a4");

    let first = true;

    for (const candidateEl of candidates) {
      const id = candidateEl.getAttribute("data-candidate-id");

      // Ako koristiš selekciju kandidata
      if (this.selectedTodPdf.length > 0 && !this.selectedTodPdf.includes(id)) {
        continue;
      }

      // Sakrij sve kandidate osim ovog
      candidates.forEach(el => {
        el.style.display = el === candidateEl ? "" : "none";
      });

      // Sakrij dugmiće
      const buttons = candidateEl.querySelectorAll("button");
      buttons.forEach(btn => btn.style.display = "none");

      // Renderuj canvas
      const canvas = await html2canvas(candidateEl, {
        scale: 2,
        useCORS: true
      });

      const imgData = canvas.toDataURL("image/png");
      const imgProps = doc.getImageProperties(imgData);
      const pdfWidth = doc.internal.pageSize.getWidth();
      //const pdfHeight = (imgProps.height * pdfWidth) / imgProps.width;

      if (!first) doc.addPage();
      const marginLeft = 10; // u pt (1pt ≈ 0.35mm, 40pt ≈ 14mm)
const marginRight = 10;
const usableWidth = pdfWidth - marginLeft - marginRight;
const scaledHeight = (imgProps.height * usableWidth) / imgProps.width;

doc.addImage(imgData, "PNG", marginLeft, 20, usableWidth, scaledHeight);
      first = false;

      // Vrati dugmiće
      buttons.forEach(btn => btn.style.display = "");
    }

    // Vrati sve kandidate
    candidates.forEach(el => {
      el.style.display = "";
    });

    doc.save("Kandidati.pdf");

    this.pdfActivate = false;
    this.letterSpacing = false;
  });
}
,
      togglePdfMark(userId) {
        const index = this.selectedTodPdf.indexOf(userId);

if (index === -1) {
  // Ako ID nije u listi, dodaj ga
  this.selectedTodPdf.push(userId);
} else {
  // Ako jeste, ukloni ga
  this.selectedTodPdf.splice(index, 1);
}

       
    const el = document.querySelector(`[data-candidate-id="${userId}"]`);
    if (el) {
      const isInPdf = el.getAttribute("data-include-in-pdf") === "true";
      el.setAttribute("data-include-in-pdf", isInPdf ? "false" : "true");
    }
  },
},
   
    async created() {
      await  this.getCompanies();
      const user = await this.getProfile();
      if(user.data.user.availableTest.interviewReport){
      if(user.data.user.type !== 'admin'  || user.data.user.sektor !== 'admin' ||  user.data.user.radnoMesto !== 'admin' ){
        this.showDropdownCompanies = false;
        await this.setSelected(user.data.user.type)
      }
    }
      this.companys.forEach(company => {
        let list = [];
        this.listOfListsOfUsers.push(list);
        if(company.name!="a"){
        this.companyList.push(company.name);
        }
      });
  
    },
  }
  </script>
  
  <style lang="css" scoped>
  
  table{
    border: 2px solid black;
    text-align: center;
  }
  td, th{
    text-align: center;
    border: 1px solid black;
  }
  tr:nth-child(even){background-color: #aaaacc;}
  tr:nth-child(odd){background-color: #ccccff;}
  tr:hover {background-color: #afa;}
  
  .container{
    margin-top: 10px;
  }
  
  .validation{
    margin-top: 5px;
    background-color: #00aaaa;
  }
  
  select option {
    white-space: nowrap;
    overflow: hidden;
    text-overflow: ellipsis;
    max-width: 100px;
  }
  
  .loader {
    border: 16px solid #f3f3f3; /* Light grey */
    border-top: 16px solid #3498db; /* Blue */
    border-radius: 50%;
    width: 120px;
    height: 120px;
    animation: spin 2s linear infinite;
  
    margin:auto;
    margin-top: 100px;
  
  }
  
  @keyframes spin {
    0% { transform: rotate(0deg); }
    100% { transform: rotate(360deg); }
  }



  .input-gray {
    background-color: rgb(209, 207, 207);
    border: 0;
}

.input-large {
    height: 200px;
    border: 0.5px solid white;
    resize: none;
}

.input-large-text {
    height: 100%;
    border: 0.5px solid white;
    white-space: pre-wrap;
}

.box-header {
    height: 50px;
    border: 0.5px solid white;
    font-size: 12px;
}

.box-header-bottom {
    height: 50px;
    border: 0.5px solid white;
}

.div-rating {
    border: 0.5px solid white;
    height: 80px;
    cursor: pointer;
}

.clicked {
    border: 7px groove rgb(6, 238, 6);
}


.height-textarea {
    height: 86%;
}

.divider{
  width:100%;
  height: 3px;
  font:bold;
  margin-top: 1rem;
  background-color: red;
}

.divider-black{
  width:100%;
  height: 3px;
  font:bold;
  margin-top: 1rem;
  background-color: black;
}

textarea {
  overflow: hidden;
  resize: none;
  min-height: 80px;
}

.margin-left{
  margin-left: 14px;
}

.candidate-wrapper {
  padding: 20px;
  border: 1px solid #ccc;
  margin-bottom: 1.5rem;
  border-radius: 8px;
  background-color: white; /* default */
  box-shadow: 0 1px 3px rgba(0,0,0,0.1);
  transition: background-color 0.3s ease;
}

.alt-bg {
  background-color: #f8f9fa; /* svetlosiva */
}

.mt-decrease{
  margin-top: -2px;
}

.letterSpacing {
  letter-spacing: 2px;
}
.input-fake-textarea {
  background-color: rgb(209, 207, 207);
  border: 0;
  padding: 0.5rem 1rem;
  white-space: pre-wrap;
  overflow-wrap: break-word;
  font-family: inherit;
  font-size: 1rem;
  line-height: 1.5;
}

.large-font{
  font-size: 22px !important;
}


.header-red {
  background-color: #dc3545 !important; /* Bootstrap "danger" */
  color: white;
}

.pdf-selected {
  background-color: #198754 !important; /* Bootstrap success zelena */
  color: white !important;
  border-color: #198754;
}

.text-justify{
  text-align: justify;
}
  </style>
  